// extracted by mini-css-extract-plugin
module.exports = {"sectionName":"Projects_sectionName__3B-NP","filler":"Projects_filler__3wf5s"};